import React, {useEffect} from 'react';
import {renderToStaticMarkup} from 'react-dom/server';
import {useDispatch} from 'react-redux';

import ContactSupportLink from '../../../../components/ContactSupportLink/ContactSupportLink';
import {InstructionModalTemplate} from '../../../../components/DataDisplay';
import SupportAndStoreTemplate from '../../../../components/SupportAndStoreTemplate/SupportAndStoreTemplate';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import * as localizationTokens from '../../../../consts/localization/localizationTokens';
import NotificationModalTypes from '../../../../enums/app/notificationModalTypes';
import useSuccessNotificationsRemover from '../../../../hooks/useSuccessNotificationsRemover';
import connectivityService from '../../../../services/device/connectivityService';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import pairingService from '../../../../services/pairingService';
import {removeNotificationType} from '../../../../state/ducks/global';

const CriticalReconnectGuide = (props) => {
    const {guideData, hideModalGuide, isReconnectFailed} = props;
    const dispatch = useDispatch();
    const {header, reconnectStepListBle, reconnectStepListUsb} = guideData;
    const localizedStrings = getLocalizedStrings();
    const isBle = connectivityService.isBle();
    const reconnectStepList = isBle ? reconnectStepListBle : reconnectStepListUsb;
    let replacedReconnectStepList;

    useEffect(() => {
        if (isReconnectFailed) {
            pairingService.disconnectAndForwardToMyDevicesPage();
        }
    }, []);

    if (!isBle && reconnectStepList) {
        const reconnectStepListText = localizedStrings[reconnectStepList];

        replacedReconnectStepList = reconnectStepListText.replace(
            localizationTokens.CONTACT_SUPPORT_LINK,
            renderToStaticMarkup(<ContactSupportLink />)
        );
    }

    useEffect(() => {
        dispatch(removeNotificationType(NotificationModalTypes.DISCONNECT_DEVICE));
    }, []);

    useSuccessNotificationsRemover();

    return (
        <InstructionModalTemplate
            className='mx-auto w-full py-10'
            subTitleKey={localizationKeys.IO_ERROR_SUB_TITLE_TEXT}
            instructionList={reconnectStepList}
            instructionText={replacedReconnectStepList}
            articleProps={{
                titleKey: header,
                className: 'lg:max-w-[724px]',
                error: true,
            }}
            instructionButtonProps={{
                primary: true,
                light: true,
                className: 'mt-10',
                onClick: hideModalGuide,
                children: localizedStrings[localizationKeys.IO_ERROR_TRY_AGAIN_BUTTON_TEXT],
            }}
        >
            <SupportAndStoreTemplate isTitleVisible />
        </InstructionModalTemplate>
    );
};

export default CriticalReconnectGuide;
